var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomEyeSlashSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-566 6588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-slash-solid",
    d: "M12,15a5.38,5.38,0,0,1-5.359-4.992L2.709,6.965A12.5,12.5,0,0,0,1.332,9.05a1.213,1.213,0,0,0,0,1.095A12.028,12.028,0,0,0,12,16.8a11.648,11.648,0,0,0,2.921-.392L12.976,14.9A5.405,5.405,0,0,1,12,15Zm11.768,2.179-4.146-3.2a12.422,12.422,0,0,0,3.047-3.828,1.213,1.213,0,0,0,0-1.095A12.028,12.028,0,0,0,12,2.4,11.555,11.555,0,0,0,6.477,3.81L1.706.123A.6.6,0,0,0,.864.229l-.736.948a.6.6,0,0,0,.105.842L22.3,19.07a.6.6,0,0,0,.842-.105l.736-.948A.6.6,0,0,0,23.769,17.175ZM16.88,11.85l-1.474-1.139a3.553,3.553,0,0,0-4.354-4.572A1.787,1.787,0,0,1,11.4,7.2a1.749,1.749,0,0,1-.058.375L8.583,5.438A5.337,5.337,0,0,1,12,4.2a5.4,5.4,0,0,1,5.4,5.4,5.272,5.272,0,0,1-.521,2.254Z",
    transform: "translate(565.999 -6585.597)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomEyeSlashSolid);
export default __webpack_public_path__ + "static/media/custom-eye-slash-solid.f6714eec381922f01bde7d725373520d.svg";
export { ForwardRef as ReactComponent };